<div class="full-width">
    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <div class="col-xs-9">
                    <enhanced-help
                        componentName="lotam-details"
                        [compact]="true"
                    ></enhanced-help>
                </div>
            </div>
            <!-- TODO: refactor the div styles to a more standardised style set for this type of details dialogue -->
            <div class="row top-buffer">
                <div class="col-xs-3 display-label">LOTAM Subject</div>
                <div class="col-xs-9 data">
                    {{ lotam.subject }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Description</div>
                <div class="col-xs-9 data pre-line">
                    {{ lotam.description }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Type</div>
                <div class="col-xs-9 data">
                    <notice-type-list-item
                        [noticeType]="lotam?.noticeType"
                    ></notice-type-list-item>
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Time</div>
                <div class="col-xs-9 data">
                    {{
                        lotam.startTime
                            | formatDateRange
                                : lotam.endTime
                                : organisation.timeZone
                    }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Upper Limit</div>
                <div class="col-xs-9 data">
                    {{ lotam.upperLimit | formatAltitudeValue: 'Unlimited' }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Lower Limit</div>
                <div class="col-xs-9 data">
                    {{ lotam.lowerLimit | formatAltitudeValue: 'SFC' }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Contact Name</div>
                <div class="col-xs-9 data">
                    {{ lotam.pointOfContact || '-' }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Contact Phone</div>
                <div class="col-xs-9 data">
                    {{ lotam.pointOfContactPhoneNumber || '-' }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Audience</div>
                <div class="col-xs-9 data">
                    {{ formatAudience[lotam.audience] }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-3 display-label">Priority</div>
                <div class="col-xs-9 data">
                    {{ formatLotamPriority[lotam.importance] }}
                </div>
            </div>

            <div class="row top-buffer" *ngIf="missionStatus != null">
                <div class="col-xs-3 display-label">Status</div>
                <div class="col-xs-9 data">
                    <span
                        class="status-block"
                        [ngClass]="
                            missionStatus | noticeStatusClass: isAcknowledged
                        "
                    >
                        {{
                            missionStatus
                                | formatNoticeStatusName: isAcknowledged
                        }}
                    </span>
                </div>
            </div>

            <div class="row top-buffer" *ngIf="missionStatus == null">
                <div class="col-xs-3 display-label">Operating Requirement</div>
                <div class="col-xs-9 data">
                    {{ formatOperatingRequirement[lotam.operatingRequirement] }}
                </div>
            </div>

            <div class="row top-buffer">
                <div class="col-xs-12 display-label">Links & Attachments</div>
                <div class="col-xs-12">
                    <links-and-attachments-list
                        [attachmentList]="lotam.attachmentList"
                        [linkList]="lotam.linkList"
                        [downloadUrlFn]="downloadUrlFn"
                    ></links-and-attachments-list>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row top-buffer">
                <div *ngIf="hasLocation" class="col-xs-12">
                    <flyfreely-map
                        #map
                        class="fill"
                        siteBoundaries
                        [organisationId]="organisation.id"
                        [mapData]="mapData$ | async"
                        [features]="missionLocationFeatures$ | async"
                        [requireCtrlToZoom]="true"
                        [enableLayerGroupsByDefault]="['LOTAM']"
                        style="width: 100%; height: Calc(100vh - 324px)"
                        (featuresLoaded)="
                            map.zoomToBoundingBox(noticeBoundingBox)
                        "
                    >
                    </flyfreely-map>
                </div>
                <div *ngIf="!hasLocation" class="col-xs-12 alert alert-danger">
                    This notice is globally applicable.
                </div>
            </div>
        </div>
    </div>
</div>
